import { NavLink, useNavigate } from "react-router-dom";
import styles from "./styles/UserWidget.module.css";
import { useEffect, useRef, useState } from "react";
import useClickOutside from "../../../hooks/useClickOutside";

const UserWidget = ({
    userName, // {string} - The current user name
    links, // {Array} - Array of objects containing the button proporties in the dropdown menu
    // the object can have these proporties:
    // body {String} - The button's text
    // icon {String} - The icon to be used, it will show the icon if provided
    // and either link {String} - The link address
    // or onClickFunction {Function} - The function to excute on click
    // if a function is provided the button will excute that function on click and if a link is provided the button will navigate to that link on click
    // if both were provided the function will take the priority
    // the link can also include a scroll to in the state. (`/summary, {"state":{"scrollTo":"closeSession"}}`)
    // in this case the it will navigate to the specified id (navigate(targetLink, targetState))
    forceClose,
}) => {
    const [showMenu, setShowMenu] = useState(false);
    const menuRef = useRef(null);
    const navigate = useNavigate();

    const handleToggleMenu = () => {
        setShowMenu((prevState) => !prevState);
    };
    const closeMenu = () => {
        setShowMenu(false);
    };

    useEffect(() => {
        closeMenu();
    }, [forceClose]);

    useClickOutside(menuRef, closeMenu);

    const handleOnClick = (callBack, link) => {
        closeMenu();
        if (callBack) {
            callBack();
        } else if (link) {
            // Extract the state from the link if avialable
            if (link.includes(",")) {
                const target = link.split(",");
                const targetLink = target[0];
                const targetState = JSON.parse(target[1]);
                // navigate to link and scroll to target

                navigate(targetLink, targetState);
            } else {
                navigate(link);
            }
        }
    };
    return (
        <div className={`${styles.user_widget_container} `}>
            <button
                className={`${styles.user_name}`}
                onMouseDown={(event) => event.stopPropagation()}
                onTouchStart={(event) => event.stopPropagation()}
                onClick={handleToggleMenu}
            >
                {userName}
            </button>
            <ul
                ref={menuRef}
                className={`${styles.menu_container} ${
                    showMenu ? styles.show : ""
                } `}
            >
                {links.map((item) => {
                    const IconComponent = item?.icon;
                    return (
                        <li key={item.body}>
                            <button
                                aria-label={`Link to ${item.body}`}
                                className={`${styles.link}`}
                                // the button behavior depends on the provided proporty
                                onClick={
                                    item.onClickFucntion
                                        ? () =>
                                              handleOnClick(
                                                  item.onClickFucntion,
                                                  undefined,
                                              )
                                        : item?.link
                                          ? () =>
                                                handleOnClick(
                                                    undefined,
                                                    item.link,
                                                )
                                          : null
                                }
                            >
                                {IconComponent && (
                                    <IconComponent
                                        className={`${styles.menu_icon} icon-component`}
                                    />
                                )}
                                <span>{item.body}</span>
                            </button>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default UserWidget;
